import React, { Component } from 'react';

import axios from 'axios';
import { connect } from 'react-redux';
import { getQueryParam } from '../utils';

const request = axios.create({
  baseURL: '/client',
  timeout: 150000, // 2 Minutes +
});

export default connect((state) => ({}))(
  class PaymentAuthorizationResult extends Component {
    state = {
      message: 'Authorization Pending',
    };
    componentDidMount() {
      const identity = getQueryParam('identity');
      if (identity) {
        request.get('/payment-authorization-result', { params: { identity } }).then((res) => {
          if (res.data.data.isVerified) {
            this.setState({ message: 'Authorization Successful 🥳!' });
          } else {
            this.setState({ message: 'Authorization Pending Verification' });
          }
        });
      }
    }
    render() {
      return (
        <div>
          {/* {this.props.location.search.indexOf('bp-no-header=true') === -1 && (
            <div>
              <div className='banner bg-img'>
                <div className='contain' />
              </div>
            </div>
          )} */}
          <div className='contain'>
            <div className='authorization' style={{ color: '#858589' }}>
              <h1
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '200px',
                  textAlign: 'center',
                }}
              >
                {this.state.message}
              </h1>
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/PaymentAuthorizationResult.js